export const AboutSection = () => (
  <section id="apropos" className="bg-white py-16 md:py-24" data-testid="about-section">
    <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
      <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-6 text-center" data-testid="about-title">À propos de nous</h2>
      <div className="space-y-5 text-gray-700 leading-relaxed">
        <p><strong className="text-gray-900">Les Entretiens Élites</strong> est une entreprise locale de services d'entretien extérieur qui dessert Châteauguay, Mercier, Léry et les environs. Nous offrons des services professionnels et fiables.</p>
        <p>Notre équipe est composée de jeunes professionnels motivés et dynamiques qui prennent leur travail à cœur. Nous croyons qu'un service de qualité commence par une attitude sérieuse, du respect et une bonne communication.</p>
        <p>Notre objectif est simple : offrir un service d'entretien extérieur de qualité, fiable et accessible, pour que nos clients puissent profiter de leur terrain en toute tranquillité.</p>
      </div>
    </div>
  </section>
);
